module.exports = __webpack_public_path__ + "img/石林县人民医院.f011b14a.png";